import * as Sentry from '@sentry/tanstackstart-react';
import { StartClient } from '@tanstack/react-start';
import { hydrateRoot } from 'react-dom/client';
import { scan } from 'react-scan';

import { createRouter } from './router';

const router = createRouter();

if (typeof window !== 'undefined') {
  const shouldShowScan =
    import.meta.env.DEV && import.meta.env.VITE_ENABLE_DEV_TOOLS !== 'false';
  scan({
    enabled: shouldShowScan,
  });
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  normalizeDepth: 10,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/timeback-staging\.alpha-1edtech\.com/,
    /^https:\/\/timeback\.alpha-1edtech\.com/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

hydrateRoot(document, <StartClient router={router} />);
